import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';

const Work = (props) => {
    const {work:{name,description,image,technology,repo,preview}} = props;
    return (
        <Card 
        style={{backgroundColor:"#172a45"}}
        >
            <article>
                <Card.Img variant="top" src={image} />
                <Card.Body>
                    <Card.Title>{name}</Card.Title>
                    <Card.Text className="small">
                    {description}
                    </Card.Text>
                    <div className="d-flex justify-content-between">
                        <div className="technology">
                            {
                                technology.map(tech =>  <span>{tech}</span>)
                            }
                        </div>
                    </div>
                </Card.Body>
                <Card.Footer>
                <ul className="preview list-inline m-0 p-0">
                        
                        {
                            repo === '#' ||
                            <li className="list-inline-item mr-3">
                                <a target="_blank" rel="noreferrer" href={repo}><FontAwesomeIcon icon={faGithub}/></a>
                            </li>
                        }
                        {
                            preview === '#' ||
                            <li className="list-inline-item">
                                <a target="_blank" rel="noreferrer" href={preview}><FontAwesomeIcon icon={faExternalLinkAlt}/></a>
                            </li>
                        }
                       
                    </ul>
                </Card.Footer>
            </article>
        </Card>
    );
};

export default Work;